import Columns from '../../grid/columns';
import ExpandButtons from '../../extensions/expandButtons';
import Config from '../../config';

export default instance => {
  instance.attachEvent('onGanttReady', () => {
    if (instance.ganttDataApi.isBase() || instance.ganttDataApi.isHistory()) {
      ExpandButtons.init(instance);
    }

    if (instance.ganttDataApi.isBase()) {
      // ExpandButtons.init(instance);

      // https://docs.dhtmlx.com/gantt/api__gantt_reorder_grid_columns_config.html
      instance.$ui.getView('grid').attachEvent('onBeforeColumnDragStart', obj => Columns.onBeforeColumnDragStart(obj));
      instance.$ui.getView('grid').attachEvent('onColumnDragMove', obj => Columns.onColumnDragMove(obj));
      instance.$ui.getView('grid').attachEvent('onBeforeColumnReorder', obj => Columns.onBeforeColumnReorder(obj));
      instance.$ui.getView('grid').attachEvent('onAfterColumnReorder', () => Columns.onAfterColumnReorder());
      // Resize columns
      instance.$ui.getView('grid').attachEvent('onColumnResizeStart', () => Columns.onColumnResizeStart());
      instance.$ui.getView('grid').attachEvent('onColumnResizeEnd', (columnIndex, column, newWidth) => {
        Columns.onColumnResizeEnd(columnIndex, column, newWidth);
      });
    }

    Config.setSkin();
    Config.drawHorizontalLine();
    instance.initCustomTimeline();
  });
};
